// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__3eRKl","lastUpdated":"PrivacyPolicy_lastUpdated__e203Y"};